import type { SurveyLanguage } from '../types/surveyLanguage';

export const SURVEY_LANGUAGE_STORAGE_KEY = 'ploomsurvey:surveyLanguage';

export const SURVEY_LANGUAGE_CODES: readonly SurveyLanguage[] = ['en', 'bm'] as const;

export function isSurveyLanguage(value: string | null | undefined): value is SurveyLanguage {
  return value === 'en' || value === 'bm';
}
